import type { ThreadEventItem } from "@/types/threadEvents.ts";
import { lastAgentText } from "./lastAgentText.ts";
import { isUnansweredForm, selectTurnOmniCards } from "./selectOmniArtifacts.ts";

/** How many questions okthx is waiting on, and its own account of why. */
export type OpenQuestions = { count: number; why?: string };

/**
 * What a task's thread says okthx is waiting on.
 *
 * The task itself carries only `needsInput`, a boolean, so anything more
 * specific is read from the thread: the unanswered form on the current turn
 * gives the count, and the last thing okthx said gives the reason. Shared
 * because both platforms draw the same line, and only their fetch differs.
 */
export function openQuestions(messages: ThreadEventItem[]): OpenQuestions {
  const form = selectTurnOmniCards(messages).find(isUnansweredForm);
  return { count: form?.form?.fields?.length ?? 0, why: lastAgentText(messages) };
}

/** "1 question" / "3 questions" — the noun every holder line counts. */
export function questionCount(n: number): string {
  return `${n} question${n === 1 ? "" : "s"}`;
}
